module.exports = __webpack_public_path__ + "img/核心价值观.8023c0dc.svg";